import type { QUnitType } from 'dayjs';
import type { ResultHistoryWindowArg } from 'src/hooks/queries/dashboardFilterArgs';

import { toIsoBounds } from '../../gigawidget/util/filterHelpers';
import type { DashboardFilter } from '../../useDashboardStore';

/**
 * COI-837 — the `seriesDateFilterOptions.dateFilter` the four nested-series
 * charts share (compliance / document / indicator / risk ratings). Each clips
 * its NESTED result series to the dashboard date range and deliberately does
 * not narrow its rows, so the callback is identical across all four; the
 * control-test chart is NOT one of them, because there the rows ARE the series
 * and it emits `dateRange.field` instead.
 *
 * `ResultHistoryWindowArg` is a subset of every one of the four register hooks'
 * argument types, so it satisfies each descriptor's `Partial<TArgs>` return.
 */
export const resultHistoryWindowFilter = (
  dateRange: DashboardFilter['dateRange'],
  precision: QUnitType
): ResultHistoryWindowArg => ({
  resultHistoryWindow: toIsoBounds(dateRange, precision),
});
